export default class UpdateCart {
  constructor(app) {
    this.app = app;

    this.update = this.update.bind(this);
  }

  update() {
    // Make sure the button is enabled before triggering the event otherwise this won't work.
    const updateCartButton = document.querySelector("[name='update_cart']");
    updateCartButton.disabled = false;
    updateCartButton.click();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/updateCart.js